// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import resetStyles from "../styles/reset.module.scss"
import classNames from "classnames"
import React from "react"
import { NodeWithChildren } from "../helpers/node-with-children"
import { PrimitiveBaseProps, PrimitiveWithSizing, PrimitiveWithChildrenProps } from "../helpers/types"

interface Props
  extends React.HTMLAttributes<HTMLDivElement>,
    PrimitiveBaseProps<HTMLDivElement>,
    PrimitiveWithSizing,
    PrimitiveWithChildrenProps {}

export function Stack(props: Props) {
  const {
    innerRef,
    className,
    direction,
    spacing,
    "data-node-id": dataNodeId,
    alignment = "start",
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props

  return (
    <NodeWithChildren
      direction={direction}
      spacing={spacing}
      alignment={alignment}
      mainAxisSizing={mainAxisSizing}
      crossAxisSpacing={crossAxisSizing}
    >
      {(nodeWithChildrenClassName) => (
        <div
          {...otherProps}
          className={classNames(resetStyles.reset, className, nodeWithChildrenClassName)}
          ref={innerRef}
          data-node-id={dataNodeId}
        />
      )}
    </NodeWithChildren>
  )
}
